import { render, staticRenderFns } from "./TargetsTable.vue?vue&type=template&id=3da5931c"
import script from "./TargetsTable.vue?vue&type=script&lang=js"
export * from "./TargetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports